import React from 'react';
import ListViewContainer from '../shared/ListViewContainer';
import Button from 'components/elements/button';
import Box from 'components/elements/Box';
import P from 'components/elements/p';

interface ILeaveListProps {
  close: () => void;
  leaveAction: () => void;
  deleteAction: () => void;
  pending?: boolean;
  isLastCurator: boolean;
}

const LeaveList: React.FC<ILeaveListProps> = (props) => {
  const { close, leaveAction, deleteAction, pending, isLastCurator } = props;

  const onClick = (): void => (!isLastCurator ? leaveAction() : deleteAction());

  return (
    <ListViewContainer
      title="Warning"
      rejectedMessage={undefined}
      close={close}
    >
      <Box>
        {!isLastCurator && (
          <>
            <P>
              If you leave this list you wil lose your curator access to this
              list. You will still be able to view this list and add it to My
              Lists.
            </P>

            <P>
              If you like to become a curator again at a later point, you will
              need a curator for this list to send you an invitation.
            </P>

            <P>Are you sure you want to leave this list?</P>
          </>
        )}
        {isLastCurator && (
          <>
            <P>
              You are the only curator for this list. To prevent orphaned lists
              we do not allow lists without a curator to exist.
            </P>

            <P>
              If you want to have the list persist after you leave, please
              invite a fellow OPUS user as a curator first. After they&apos;ve
              accepted the invite you can leave the list without it being
              deleted.
            </P>

            <P color="NegativeChange">
              Are you sure you want to leave and delete this list for all users?
            </P>
          </>
        )}
      </Box>

      <Box
        mt={'2em'}
        display="flex"
        justifyContent="flex-end"
        alignItems="flex-end"
        mb={'2em'}
      >
        <Button
          onClick={close}
          variant={pending ? 'disabled' : 'secondary'}
          alignSelf="auto"
          fontWeight={600}
          disabled={pending}
        >
          Cancel
        </Button>
        <Button
          fontWeight={600}
          variant={pending ? 'disabled' : 'destructive'}
          alignSelf="auto"
          marginLeft=".5em"
          onClick={onClick}
          data-gtag={
            isLastCurator ? 'custom-list-delete-list' : 'custom-list-leave-list'
          }
        >
          {isLastCurator ? 'Leave and delete list' : 'Leave List'}
        </Button>
      </Box>
    </ListViewContainer>
  );
};

export default LeaveList;
